import { createStore, applyMiddleware, compose } from 'redux';
import {
  useDispatch,
  useSelector,
  useStore,
  TypedUseSelectorHook
} from 'react-redux';
import thunk from 'redux-thunk';
import ApiMiddleware from './api/middleware';
import rootReducer from './reducers';
import ServiceMiddleware from './_clean-code/services/stateManager/serviceMiddleware';
import { PreloadedState } from '@reduxjs/toolkit';

const middlewares = [ApiMiddleware, ServiceMiddleware, thunk];
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as typeof compose) || compose;
const store = setupStore();

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export function setupStore(preloadedState: PreloadedState<RootState> = {}) {
  return createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
}

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => AppStore = useStore;
